/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import {
  AbstractFormComponent,
  BuilderNavigationService,
  CommonActions,
  FormActionPipelines,
  FormFlowState,
} from '@gh/builder-shared';
import { AelEvents } from '@gh/builder-shared-data';
import { ActionFlow, getRouteInitData } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { DialogService, yesAnswer, yesNoConfirmation } from '@gh/core-ui';
import { filter$ } from '@gh/rx/operators';

import { assign } from 'lodash';

import { SystemVarsAccountsTwilio } from '../../../resources/model/system-vars-accounts.model';
import { SystemVarsAccountsTabBusinessService } from '../../../resources/system-vars-accounts-tab-business.service';
import { SystemVarsAccountsTwilioFormState } from './system-vars-accounts-twilio-form.service';

@Component({
  selector: 'gh-system-vars-accounts-nexmo-subtab',
  template: require('./system-vars-accounts-twilio-subtab.component.html'),
  viewProviders: [
    SystemVarsAccountsTwilioFormState,
  ],
})
export class SystemVarsAccountsTwilioTabComponent extends AbstractFormComponent<SystemVarsAccountsTwilio> implements OnInit {
  @ViewChild('twilioWebhook', { static: true }) twilioWebhookEl: ElementRef;
  @ViewChild('twilioWebhookUrlPhoneCalls', { static: true }) twilioWebhookUrlPhoneCallsEl: ElementRef;

  private originalTwilio: SystemVarsAccountsTwilio;

  constructor(
    public form: SystemVarsAccountsTwilioFormState,
    private route: ActivatedRoute,
    private systemVarsBusiness: SystemVarsAccountsTabBusinessService,
    private navigationService: BuilderNavigationService,
    private dialogService: DialogService,
    private pipelines: FormActionPipelines,
    private actions: CommonActions,
  ) {
    super();
  }

  ngOnInit(): void {
    const { originalTwilio } = getRouteInitData(this.route);
    assign(this, { originalTwilio });
    this.form.build(originalTwilio);
  }

  get completeFlow(): ActionFlow<FormFlowState<SystemVarsAccountsTwilio>> {
    return this.pipelines.complete({
      execute: this.actions.execute((state: FormFlowState<SystemVarsAccountsTwilio>) =>
        this.systemVarsBusiness.updateNexmo(state.form.submitValue)),
      finish: (state: FormFlowState<SystemVarsAccountsTwilio>) => {
        const { value } = state;
        this.originalTwilio = value;
        this.form.build(value);
      },
    });
  }

  onReset(): void {
    this.dialogService
      .confirmation(yesNoConfirmation('msg_reset')).pipe(
      filter$(yesAnswer))
      .subscribe(() => {
        this.form.build(this.originalTwilio);
      });
  }

  copyUrl(type: string): void {
    this[type].nativeElement.select();
    document.execCommand('copy');
  }

  goToAel(entityId?: ID, entityType?: string, label?: string): void {
    this.navigationService.goToAel({
      entityId: entityId ? entityId : undefined,
      entityType: entityType ? entityType : 'OFFICE',
      eventTypeIds: [AelEvents.Office.IntegrationAccounts],
      label: label ? label : 'lbl_integration_accounts',
    });
  }
}
